<template>
  <form @submit.prevent="onRegister" class="mb-3">
    <input v-model="name" class="form-control mb-2" placeholder="Nombre" required />
    <input v-model="shelly_id" class="form-control mb-2" placeholder="Shelly Device ID" required />
    <input v-model="auth_key" class="form-control mb-2" placeholder="Auth Key" required />
    <select v-model="type" class="form-select mb-2" required>
      <option value="switch">Shelly 1 / Plus 1 (Switch)</option>
      <option value="shelly-3em">Shelly Pro 3EM</option>
      <option value="shelly-pro4pm">Shelly Pro 4PM</option>
      <!-- Agrega más tipos si deseas -->
    </select>
    <input v-model="notes" class="form-control mb-2" placeholder="Notas" />
    <button class="btn btn-primary btn-sm w-100" type="submit">Agregar dispositivo</button>
    <span v-if="msg" style="color:green">{{ msg }}</span>
  </form>
</template>
<script>
import api from "../api/api";
export default {
  data() {
    return { name: "", shelly_id: "", auth_key: "", notes: "", type: "switch", msg: "" };
  },
  methods: {
    async onRegister() {
      await api.createDevice({
        name: this.name,
        shelly_id: this.shelly_id,
        auth_key: this.auth_key,
        notes: this.notes,
        type: this.type,
      });
      this.msg = "Dispositivo agregado";
      this.name = this.shelly_id = this.auth_key = this.notes = "";
      this.type = "switch";
      this.$emit("deviceAdded");
    },
  },
};
</script>
